/** Created by azhou on 2019/3/27.*/
<template> 
    <div class="border rounded p-3 pb-0 businesslist-search-con">
      <div>
        <left-text-select class="  mb-3 mr-4" leftText="订单状态" :options="tabArr " v-model="status" @input="searchSubmit" :width="60"/>
        <left-text-select class="  mb-3 mr-4" leftText="人员" :options="PersonnelList " v-model="uid"  @input="searchSubmit" :width="40"/>
        <left-text-select class="  mb-3 mr-4" leftText="收款模式" :options="brokerList " v-model="broker"  @input="searchSubmit" :width="60"/>
        <left-text-select class="  mb-3 mr-4" leftText="已支付" :options=" pay_flagList " v-model="pay_flag"  @input="searchSubmit" :width="60"/>
      </div>
      <div>
        <left-text-border class=" mb-3 mr-4" leftText="订单号" v-model="orderNum"  @enter="searchSubmit" :width="60"/>
        <left-text-border class=" mb-3 mr-4" leftText="团号" v-model="title" v-show="orderType===3" @enter="searchSubmit" :width="40"/>
        <left-text-border class=" mb-3 mr-4" v-show="orderType!==1 && orderType!==7 &&userInfo.type!==3"  :leftText="`${storeType.cn}名称`" v-model="name" @enter="searchSubmit" :width="60"/>
        <div class=" mb-3 d-center-start mr-4" v-if="$GFUN.isInArray([3,5,6,7,8],orderType)">
          <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width: 260px;">
            <el-option v-for="item in timeChoose" :key="item.value" :label="item.name" :value="item.value" />
          </el-select>
          <el-date-picker v-model="timestamp" type="daterange" class="w-100" size="small"
                  v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
                  range-separator="至" value-format="timestamp" start-placeholder="开始时间"
                  end-placeholder="结束时间" />
          <el-date-picker type="dates" v-model="timetime" class="w-100" size="small" 
                          v-show="timeType === 'timeArr'" placeholder="可选择一个或多个日期" />
        </div>
        <div class=" mb-3 d-center-start" v-if="$GFUN.isInArray([1],orderType)">
          <left-text :leftText="storeType.left"/>
          <el-date-picker v-model="timestamp" size="small" type="daterange" class="w-100" range-separator="至" 
            value-format="timestamp" :start-placeholder="storeType.start" :end-placeholder="storeType.end" />
        </div>
      </div>
      <div class="w-6 text-right ml-auto mb-3 mr-4">
        <el-button type="primary" size="small" class="w-100" icon="el-icon-search" @click="searchSubmit">搜索</el-button>
      </div>
    </div>
</template>

<script>
  import { mapGetters,mapState} from 'vuex'
  export default {
    name: 'SearchCon',
    props:{
      orderType:{},
      PersonnelList:{}
    },
    computed: {
      ...mapGetters(['storeInfo','userInfo','isAdmin']),
      ...mapState(['userLoginMessage']),
      orderStatus() { return this.$route.query.orderStatus },

      storeType() {
        switch (this.orderType) {
          case 3:return {cn:'酒店',left:'入住日期',start:'入住日期',end:'离店日期'}
          case 5:return {cn:'民宿',left:'入住日期',start:'入住日期',end:'离店日期'}
          case 6:return {cn:'景区',left:'出行时间',start:'开始日期',end:'结束日期'}
          case 7:return {cn:'度假产品',left:'出行时间',start:'开始日期',end:'结束日期'}
          case 8:return {cn:'品牌馆',left:'出行时间',start:'开始日期',end:'结束日期'}
          case 1:return {cn:'门店',left:'购买时间',start:'开始日期',end:'结束日期'}
          default:return {cn:'门店'}
        }
      },
      timeChoose() {
        let string = this.$GFUN.isInArray([6,8],this.orderType) ? '出行' : '入住';
        let arr =  [
          {name:`按${string}时间段`,value:'timeFrame'},
          {name:`按入住日`,value:'timeArr'},
        ];
         arr.push({name:`按发单时间`,value:'postTime'},{name:`按成交时间`,value:'dealTime'},)
        return arr
      }
    },
    data() {
      return {
        timestamp: [],
        timetime:[],
        orderNum:'',
        title:'',
        name:'',
        company:'',
        status:'',
        buyermobile: '',
        tabArr:[
            {name: '全部', id: ''},
            {name: '询价中', id: '4', value:'red'},
            {name: '待入住', id: '7',value:'Orange'},
            {name: '已入住', id: '8'},
            {name: '完成', id: '9'},
            {name: '取消',id: '99'},
            {name: '今日入住', id: 'today',value:'green'},
            {name: '入住中', id: 'stay',value:'green'},
        ],
        brokerList:[
            {name: '全部', id: ''},
            {name: '代收款', id: '1'},
        ],
        pay_flagList:[
            {name: '全部', id: ''},
            {name: '已支付', id: '1'},
             {name: '未支付', id: '2'},
        ],
        uid:'',
        timeType:'timeFrame',
        broker:'',
        pay_flag:'',
      }
    },
    mounted() {
      this.uid=this.userLoginMessage.uid;
    },
    watch: {
      'orderType':'initSearchCon',
      'orderStatus':'initSearchCon',
    },
    methods:{
      //清空搜索条件
      initSearchCon() {
        this.timestamp = [];
        this.orderNum = '';
        this.name = '';
        this.name = '';
        this.company = '';
        this.buyermobile = '';
        if (this.orderType === 1) this.timeType = 'timeFrame';
        else this.timeType = 'timeFrame';
      },
      //提交搜索条件
      searchSubmit() {
        let data = {
          oid:this.orderNum,
          name:this.name,
          hotel_name:this.name,
          travel_name:this.company,
          status:this.status,
          uid:this.uid,
          broker:this.broker,
          pay_flag:this.pay_flag,
          // occupant_mobile: this.buyermobile
        }
        let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
        let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
        switch (this.timeType) {
          case 'timeArr':
            let timeArr = this.timetime ? this.timetime.map(v => {return ((v.getTime() / 1000) + (this.$GFUN.isInArray([7,8],this.orderType) ? 28800 : 0))}) : [];
            data.date_in = timeArr.join(',');
            break;
          case 'timeFrame':
            data.date_in = start;
            data.date_out = end;
            break;
          case 'postTime':data.add_time = start + ',' + end; break;
          case 'dealTime':data.deal_time = start + ',' + end; break;
        }
        this.$emit('getSearchCon',data);
      }
    }
  }
</script>
<style scoped  lang="scss">
  .businesslist-search-con{
    width: 100%;
    div{
      display: flex;
          .mr-4{
        width: 25%;
      }
    }
  }
  .w-6{
    width: 120px;
  }
</style>
